import React, {useContext} from 'react';
import {Route, useHistory, useParams, withRouter} from "react-router-dom";
import {Typography} from "antd";
import PropTypes from 'prop-types';

import BaseLayout from "../layout/baseLayout/baseLayout";
import {replaceUrlByParams} from "../utils/api";
import {PAGE} from "../utils/constants";
import {AppContext} from "../App";

PublicRouter.propTypes = {
    children: PropTypes.node,
    component: PropTypes.func
}

function PublicRouter({component: Component, ...rest}) {
    let history = useHistory()
    const {pid} = useParams()
    const {Title} = Typography
    const {appSetting} = useContext(AppContext)
    
    const logoText = pid ?
        <a onClick={() => history.push(`${replaceUrlByParams(PAGE.LANDING, {':pid': pid})}`)} className='logo'>
            <img src={ appSetting.logo } alt='logo' />
        </a> :
        <Title className='logo-text' level={4}>Enrolment Program</Title>

    return (
        <BaseLayout
            logoSection={logoText}
        >
            <Route {...rest} render={props => (
                <Component {...props} />
            )} />
        </BaseLayout>
    );
}

export default withRouter(PublicRouter);
